<template>
  <img
    :id="settings.id"
    :src="settings.imgSrc[$i18n.locale]"
    :alt="$t('label.ticketGoogleWallet')"
    class="google-wallet-button"
    @click="$emit('start-download', ticket)"
  >
</template>

<script>
  import walletPt from 'assets/apps/add_to_google_wallet_pt.png';
  import walletEn from 'assets/apps/add_to_google_wallet_en.png';
  import walletEs from 'assets/apps/add_to_google_wallet_es.png';

  export default {
    name: 'DownloadTicketGoogleWalletComponent',
    props: {
      ticket: {
        type: Object,
        default: () => {},
      },
    },
    data: () => ({
      settings: {
        id: 'download-wallet',
        imgSrc: {
          'pt-br': walletPt,
          'en-us': walletEn,
          es: walletEs,
        },
      },
    }),
  };
</script>

<style scoped>
.google-wallet-button{
  width:200px;
  cursor: pointer;
}
</style>
